import { render } from "./block-contact.vue?vue&type=template&id=50654e0d"
import script from "./block-contact.vue?vue&type=script&lang=js"
export * from "./block-contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__